export default __webpack_public_path__ + "static/media/cusco-street_alley.e0fdf0a7.jpg";